import React, { lazy, memo, NamedExoticComponent } from 'react'

const MDXRuntime = lazy(() => import('../components/MDXRuntime'))

export const MemoMDX: NamedExoticComponent<{
  mdx: string
}> = memo(({ mdx }) => <MDXRuntime mdx={mdx} />)
